module.exports = __webpack_public_path__ + "img/desaparecidos4.5356402e.jpg";